import React from "react";
import PropTypes from "prop-types";
import NotificationAlert from "react-notification-alert";
import isEmpty from "lodash/isEmpty";
import Validator from "validator";
import { connect } from "react-redux";
import { PulseLoader } from "react-spinners";
import { resetPassword } from "../../modules/actions/authActions";

function validateInput(data) {
  let errors = {};
  if (Validator.isEmpty(data.newPassword)) {
    errors.newPassword = "This field is required";
  }
  if (Validator.isEmpty(data.verifyPassword)) {
    errors.verifyPassword = "This field is required";
  }
  if (!Validator.equals(data.newPassword, data.verifyPassword)) {
    errors.verifyPassword = "Passwords must match";
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class ResetPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      verifyPassword: "",
      errors: {},
      successMsg: "",
      isLoading: false,
      invalid: false
    };
  }

  _onChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  handleResetPassword = event => {
    event.preventDefault();
    if (this.isValid()) {
      const { newPassword, verifyPassword } = this.state;
      const token = this.context.router.route.match.params.id;

      const emailPayload = {
        newPassword,
        verifyPassword,
        token
      };
      this.setState({ errors: {}, isLoading: true });
      this.props
        .resetPassword(emailPayload)
        .then(data => {
          console.log(data);
          if (data.status) {
            this.setState({ isLoading: false });
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                <div>
                  <div>
                    <b>{data.message}</b>
                  </div>
                </div>
              ),
              type: "success",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          } else {
            this.setState({ isLoading: false });
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                <div>
                  <div>
                    <b>{data.message}</b>
                  </div>
                </div>
              ),
              type: "danger",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          }
        })
        .catch(error => {
          this.setState({ isLoading: false });
          this.refs.notify.notificationAlert({
            place: "tc",
            message: (
              <div>
                <div>
                  <b>{error.response.data.message}</b>
                </div>
              </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
          });
        });
    }
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  componentDidMount() {
    this.attachKeyupListenerToInputElements();
  }

  attachKeyupListenerToInputElements = () => {
    let self = this;
    let inputs = document.querySelectorAll("input");
    for (let i = 0; i < inputs.length; i += 1) {
      inputs[i].addEventListener("keyup", keyupHandler);
    }

    function keyupHandler(event) {
      event.preventDefault();
      if (event.keyCode === 13) {
        self.handleResetPassword(event);
      }
    }
  };

  render() {
    console.log(this.context.router.route.match.params.id);
    const { errors, verifyPassword, newPassword } = this.state;
    return (
      <section className="section bg-gradient text-white">
        <div className="container">
          <div className="row">
            <PulseLoader
              className="sweet-loading"
              sizeUnit={"px"}
              size={20}
              color={"#123abc"}
              loading={this.state.isLoading}
            />
            <div className="col-lg-12">
              <div className="text-center">
                <h2 className="font-weight-bold">RESET YOUR PASSWORD</h2>

                <div className="row">
                  <NotificationAlert ref="notify" />
                  <div className="col-lg-3" />
                  <div className="col-lg-6">
                    <div className="form-group mt-3">
                      <input
                        type="password"
                        name="newPassword"
                        className="form-control"
                        placeholder="Enter New Password"
                        onChange={this._onChange}
                        value={newPassword}
                      />
                      {errors.newPassword && (
                        <span className="error-color-dash">
                          {errors.newPassword}
                        </span>
                      )}
                    </div>

                    <div className="form-group mt-3">
                      <input
                        type="password"
                        name="verifyPassword"
                        className="form-control"
                        placeholder="Confirm New Password"
                        onChange={this._onChange}
                        value={verifyPassword}
                      />
                      {errors.verifyPassword && (
                        <span className="error-color-dash">
                          {errors.verifyPassword}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3" />
                </div>

                <div style={{ clear: "both", height: "40px" }} />

                <a
                  href="javascript:void(0)"
                  onClick={this.handleResetPassword}
                  className="btn btn-outline-white"
                >
                  SUBMIT
                </a>

                <div style={{ clear: "both", height: "100px" }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

ResetPasswordForm.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}
export default connect(
  mapStateToProps,
  {
    resetPassword
  }
)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/pages/resetPassword/ResetPasswordForm.js